"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(interpolator, n) {
  var samples = new Array(n);

  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));

  return samples;
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-interpolate/src/quantize.js
// module id = 6860
// module chunks = 0